import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import { connect } from 'react-redux';

import ContactSubscriptionPage from './ContactSubscriptionPage';
import UserSubscriptionPage from './UserSubscriptionPage';

import * as CoreActions from '../../actions/coreActions';
import * as SubscriptionActions from '../../actions/subscriptionActions';

import ProtectedRoute from '../../components/ProtectedRoute';

class Subscriptions extends Component {

    async componentDidMount() {
        const { setProgressBarLoading, fetchSubscriptions } = this.props;

        setProgressBarLoading(true);

        await fetchSubscriptions('users');
        await fetchSubscriptions('contacts');

        setProgressBarLoading(false);
    }

    render() {
        let { currentScopes } = this.props;

        if (!currentScopes) {
            return null;
        }

        return (
            <Switch>
                <ProtectedRoute
                    component={ContactSubscriptionPage}
                    path="/subscriptions/contact"
                    permissions="subscriptionFull"
                />

                <Route component={UserSubscriptionPage} path="/subscriptions/" />
            </Switch>
        );
    }
}

const mapStateToProps = state => {
    return {
        currentScopes: state.core.currentScopes
    };
};

const mapDispatchToProps = {
    ...CoreActions,
    ...SubscriptionActions
};

export default connect(mapStateToProps, mapDispatchToProps)(Subscriptions);
